import { Box, ButtonNew, ColorOptions, Icon, Image, Spacer, TextNew } from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/native'
import { observer } from 'mobx-react'
import { FC, useRef, useState } from 'react'
import { Animated } from 'react-native'
import { ProductBox } from '../../comps/ProductBox'
import { footerStrings, staticStrings } from '../../static/staticStrings'
import { colors } from '../../util/colors'
import usePadding from '../../util/usePadding'
import { ENABLE_JIOPAY_FOR_CONSUMER, isTabletWidth, useWindowDimensions } from '../../util/util'
import { ModBox } from '../ModifiedBox/ModifiedBox'
import { animate } from './BottomAnimation'
import { styles } from './styles'

const ImageJio = require('../../assets/svg/jiobizz-mark.svg')

interface NavProps {
  onPress: () => void
  isBg?: boolean
  isLightBackground?: boolean
  hideRightMenu?: boolean
  hamBurgerType?: 'primary' | 'secondary'
  showSignin?: false
}

export const htmlRouting = (url: string): void => {
  if (window && document) {
    const element = document.getElementById(url)
    element?.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'start',
    })
  }
}

export const handleLogin = (): void => {
  window.open('https://dashboard.jiopay.com/login', '_blank')
}

interface NavButtonInterface {
  handleHover?: (hovering: boolean) => void
  onPress: () => void
  title?: string
  type?: 'products' | 'contact' | 'partner-program'
  themedStyle?: any
  color?: ColorOptions
  productRef: any
}

const NavButton = ({ handleHover, onPress, title, type, themedStyle, color, productRef }: NavButtonInterface) => {
  const isProductButton = type === 'products'
  return (
    <Box
      {...themedStyle.productButton()}
      onPress={() => onPress()}
      onHover={(hovering: boolean) => handleHover && handleHover(hovering)}>
      <TextNew color={color ?? 'WHITE'} fontSize={14} lineHeight={21} fontFamily={'jiotype-medium'} title={title} />
      <Animated.View style={[themedStyle.bottomGradient(isProductButton), { width: productRef }]} />
    </Box>
  )
}

const Navbar: FC<NavProps> = ({ onPress, hideRightMenu = false, showSignin = false }: NavProps) => {
  console.log('hi')
  const isLightBackground = true
  const isBg = false
  const hamBurgerType = 'secondary'
  const navigate = useNavigation().navigate
  const viewPortWidth = useWindowDimensions()
  const [productModalVisible, toggleProductModal] = useState(false)
  const respPadding = usePadding()
  const themedStyle = styles(viewPortWidth, respPadding)
  const isIpad = isTabletWidth(viewPortWidth)
  const color = isLightBackground ? ('BLACK' as ColorOptions) : undefined
  const productRef = useRef(new Animated.Value(0)).current

  const hideProductModal = () => {
    toggleProductModal(false)
    animate(productRef, 0)
  }

  const showProductModal = () => {
    toggleProductModal(true)
  }

  const onContactUsClicked = () => {
    navigate('contact')
  }

  const onPartnerProgramClicked = () => {
    navigate('partner-program')
  }

  const onAboutUsClicked = () => {
    navigate('about-us')
  }

  const onJiopayConsumersClicked = () => {
    navigate('jio-pay-consumers')
  }

  const handleNavigation = () => {
    navigate('jiopay')
  }

  const handleHover = (hovering: boolean): void => {
    if (hovering) {
      showProductModal && showProductModal()
      animate(productRef, 62)
    }
  }

  const handleNav = () => {
    if (isIpad) {
      showProductModal()
    } else {
      return
    }
  }

  const handleContactUsHover = () => {
    hideProductModal && hideProductModal()
    animate(productRef, 0)
  }

  return (
    <Box height={72}>
      <Box
        {...themedStyle.navbar}
        bg={hideRightMenu ? ('#F6F7FA' as ColorOptions) : isBg ? ('WHITE' as ColorOptions) : 'WHITE'}>
        <Box underlayColor="TRANSPARENT" onPress={handleNavigation}>
          <Box flexDirection={'row'} align={'center'} justify={'center'}>
            <Box pt={1}>
              <Image resizeMode="contain" source={ImageJio} {...themedStyle.imageLogo} />
            </Box>
            <Spacer direction="horizontal" size={8} />
            <TextNew
              title={'JioPay Business'}
              color={isLightBackground ? 'BLACK' : 'WHITE'}
              fontSize={17}
              fontFamily={'jiotype-bold'}
            />
          </Box>
        </Box>
        <ModBox {...themedStyle.nav} show={!hideRightMenu}>
          <NavButton
            onPress={handleNav}
            color={color}
            themedStyle={themedStyle}
            handleHover={(hovering) => handleHover(hovering)}
            title={staticStrings.products}
            productRef={productRef}
            type="products"
          />
          <NavButton
            onPress={onPartnerProgramClicked}
            color={color}
            handleHover={() => handleContactUsHover()}
            title={staticStrings.partnerProgram}
            type="partner-program"
            themedStyle={themedStyle}
            productRef={productRef}
          />
          <NavButton
            onPress={onContactUsClicked}
            color={color}
            handleHover={() => handleContactUsHover()}
            title={staticStrings.contact}
            type="contact"
            themedStyle={themedStyle}
            productRef={productRef}
          />
          <NavButton
            onPress={onAboutUsClicked}
            color={color}
            handleHover={() => handleContactUsHover()}
            title={footerStrings.about}
            type="contact"
            themedStyle={themedStyle}
            productRef={productRef}
          />
          {ENABLE_JIOPAY_FOR_CONSUMER && (
            <NavButton
              onPress={onJiopayConsumersClicked}
              color={color}
              handleHover={() => handleContactUsHover()}
              title={staticStrings.jiopayForConsumers}
              type="contact"
              themedStyle={themedStyle}
              productRef={productRef}
            />
          )}
          {showSignin && (
            <Box {...themedStyle.navButttons}>
              <ButtonNew
                onPress={handleLogin}
                height={32}
                color={isLightBackground ? (colors.HIGHLIGHT as ColorOptions) : 'WHITE'}
                borderRadius={4}
                children={
                  <TextNew
                    color={isLightBackground ? 'WHITE' : (colors.JIO_PRIMARY_ALPHA as ColorOptions)}
                    fontSize={12}
                    fontFamily={'jiotype-medium'}
                    title={staticStrings.signin}
                  />
                }
                hoverColor={isLightBackground ? 'WHITE' : (colors.BUTTON_BLUE as ColorOptions)}
                width={92}
              />
            </Box>
          )}
        </ModBox>
        <ModBox
          show={!hideRightMenu}
          {...themedStyle.arrowRight}
          underlayColor="TRANSPARENT"
          onPress={onPress}
          backgroundColor={(hamBurgerType === 'secondary' ? colors.HOVER_SOLID : '#FFFFFF29') as ColorOptions}>
          <Icon
            id={'HAMBURGER_MENU'}
            color={hamBurgerType === 'secondary' ? colors.JIO_PRIMARY_ALPHA : 'WHITE'}
            size={16}
          />
        </ModBox>
      </Box>
      <ProductBox
        visible={productModalVisible}
        showProductModal={showProductModal}
        hideProductModal={hideProductModal}
      />
    </Box>
  )
}

export default observer(Navbar)
